import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActionButtonOption, StudyGroupInfo, StudyInfo } from './study-group-info';
import { Observable } from 'rxjs';
import { SampleTrackingDialogService } from '../service/dialog-service/sample-tracking-dialog-service';
import { SampleTrackingDialogResult, SampleTrackingResultAction } from '../service/dialog-service/sample-tracking-result';
import { map, switchMap, sample } from 'rxjs/operators';
import { SampleTrackingActionService } from '../service/sample-tracking-action-service';
import { Router } from '@angular/router';
import { UrlBuilder } from '../../core';
import { SampleTrackingStorage } from '../sample-tracking-storage';

@Component({
    selector: 'study-group-card',
    template: require('./study-group-card.component.html'),
    styles: [require('./study-group-card.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class StudyGroupCardComponent {

    @Input()
    public studyGroupInfo: StudyGroupInfo;

    @Input()
    public actionButtonOption: ActionButtonOption;
    
    @Input()
    public allStudyGroups: StudyGroupInfo[];

    @Input()
    public searchTerm: Observable<string>;

    public messageText: string;

    public isSuccess = false;

    constructor(
        private readonly sampleTrackingDialogService: SampleTrackingDialogService,
        private readonly sampleTrackingActionService: SampleTrackingActionService,
        private urlBuilder: UrlBuilder
    ) { }

    public async viewStudyGroup(studyGroupInfo: StudyGroupInfo) {
        if (this.actionButtonOption.isRouteToDashboard) {
            localStorage.setItem('dashboardData', JSON.stringify(studyGroupInfo));
            this.urlBuilder
                .esa()
                .sampletracking()
                .studyGroup(studyGroupInfo)
                .navigate();
            return;
        }

        const dialogResult = await this.showViewDialog(this.studyGroupInfo).toPromise();

        if (dialogResult.action === SampleTrackingResultAction.delete) {
            await this.deleteStudyGroup();
        }

        if (dialogResult.action === SampleTrackingResultAction.edit) {
            await this.editStudyGroup();
        }
    }

    public async deleteStudyGroup() {
        const dialogResult = await this.showDeleteDialog(this.studyGroupInfo).toPromise();

        if (dialogResult.action === SampleTrackingResultAction.delete) {
            await this.sampleTrackingActionService.deleteStudyGroup(dialogResult.groupPk);
        }
    }

    public showDeleteDialog(studyGroupInfo: StudyGroupInfo): Observable<SampleTrackingDialogResult> {
        return this.sampleTrackingDialogService.showDeleteDialog(studyGroupInfo).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult || { action: SampleTrackingResultAction.close })
        );
    }

    public showViewDialog(studyGroupInfo: StudyGroupInfo): Observable<SampleTrackingDialogResult> {
        return this.sampleTrackingDialogService.showViewDialog(studyGroupInfo).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult || { action: SampleTrackingResultAction.close })
        );
    }

    public getToolTip(cardStudyList: StudyInfo[]) {
        return cardStudyList.slice(10).map(item => '  ' + item.cardProtocolCode);
    }
    public async editStudyGroup() {
        const dialogResult = await this.showEditDialog(this.studyGroupInfo).toPromise();

        if (dialogResult.action === SampleTrackingResultAction.edit) {
            await this.sampleTrackingActionService.editStudyGroup(dialogResult.editRequest);
        }
    }

    public showEditDialog(studyGroupInfo: StudyGroupInfo): Observable<SampleTrackingDialogResult> {
        return this.sampleTrackingDialogService.showEditDialog(this.allStudyGroups, this.studyGroupInfo).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult || { action: SampleTrackingResultAction.close })
        );
    }
}
